import * as z from 'zod';
/** `no_show`: ended without being checked in. Staff can still check it in afterwards. */
export const ReservationItemStatus = z.enum(['pending', 'cancelled', 'returned', 'delivered', 'checkout_overdue', 'no_show']);
